const hostname = window.location.hostname
const targetHost = hostname.includes('localhost') ? 'staging.career.io' : hostname

export const HOW_TO_NEGOTIATE_OFFER_URL = `https://${targetHost}/career-advice/how-to-negotiate-salary-after-a-job-offer`

export const SHOULD_I_NEGOTIATE_OFFER_URL = `https://${targetHost}/career-advice/should-i-negotiate-my-job-offer`

export const REJECT_OFFER_URL = `https://${targetHost}/career-advice/reject-an-offer`
